import { pathOr } from "ramda";
import React from "react";
import {TailSpin} from "react-loader-spinner";
import "../../Styles/loadingSpinner.scss";
import useWindowSize from "../../utils/viewport";

export default function LoadingSpinner({
  bgColor = "#131722",
  height = "100vh",
  padding,
  position = "absolute"
}) {
  const primaryTxtColor = 'rgb(255, 81, 47)';
  const size = useWindowSize();
  const getWidth = pathOr(600, ["width"])(size);
  return (
    <div
      className="spinner-container d-flex align-items-center justify-content-center"
      style={{
        minHeight: height,
        width: "100%",
        background: bgColor,
        padding: padding,
        position: position,
        zIndex: 999,
        top: 0,
        overflow: "hidden",
      }}
    >
      <center>

      <TailSpin
        type="TailSpin"
        color={primaryTxtColor}
        height={getWidth > 600 ? 80 : 60}
        width={getWidth > 600 ? 80 : 60}
      />
      </center>
    </div>
  );
}